import { isDefined } from "../../helpers";
export function getNextTaskId({ store, id }) {
    const filtered = isDefined(store.getState()?.filter);
    const hideCompleted = store.getState()?.taskShape?.completed?.taskHide;
    const task = store.getTask(id);
    const parentChildren = store.getChildrenIds({
        id: task?.parent,
        tree: true,
        filtered,
        hideCompleted,
    });
    let nextId = null;
    if (isDefined(task?.parent) &&
        (parentChildren.length === 1 || parentChildren.at(-1) === task.id)) {
        nextId = store.getNearId({
            id: task.id,
            dir: "prev",
            flat: true,
            filtered,
            hideCompleted,
        });
    }
    else {
        nextId =
            store.getNearId({
                id: task.id,
                flat: true,
                filtered,
                hideCompleted,
            }) ||
                store.getNearId({
                    id: task.id,
                    dir: "prev",
                    flat: true,
                    filtered,
                    hideCompleted,
                });
    }
    return nextId;
}
//# sourceMappingURL=common.js.map